import { ROW_GUTTER } from "@constants";
import { MODAL_TYPE } from "@utils/constants";
import { Button, Col, ConfigProvider, Form, Row } from "antd";
import { FormInstance } from "antd/lib";
import React from "react";
import { useTranslation } from "react-i18next";
import { CommonModalWrapper } from "./CommonModalStyled";

type TCommonModalProps = {
  isLoading?: boolean;
  title: React.ReactNode;
  visible: boolean;
  modalType: string;
  form: FormInstance;
  onClose: (value: boolean) => void;
  handleValidateForm: () => void;
  handleOpenModalConfirmFinal: () => void;
  handleFinalAction: () => void;
  isCloseIcon: boolean;
  width: number;
  isMaskClosable: boolean;
  fieldData: any[];
  isDisableBtnNext: boolean;
};
const CommonModal = (props: TCommonModalProps) => {
  const { t } = useTranslation();

  const handleAction = (modalType: string) => {
    switch (modalType) {
      case MODAL_TYPE.CONFIRM_UPDATE:
        props.handleOpenModalConfirmFinal();
        break;
      case MODAL_TYPE.CONFIRM_REGISTRATION:
        props.handleOpenModalConfirmFinal();
        break;
      case MODAL_TYPE.REGISTRATION:
        props.handleValidateForm();
        break;
      case MODAL_TYPE.UPDATE:
        props.handleValidateForm();
        break;
      case MODAL_TYPE.CONFIRM_REGISTRATION_FINAL:
        props.handleFinalAction();
        break;
      case MODAL_TYPE.CONFIRM_UPDATE_FINAL:
        props.handleFinalAction();
        break;
      default:
        break;
    }
  };

  const handleRenderTextButton = (modalType: string) => {
    switch (modalType) {
      case MODAL_TYPE.DELETE:
        return t("COMMON.OK");
      case MODAL_TYPE.CONFIRM_UPDATE_FINAL:
        return t("COMMON.OK");
      case MODAL_TYPE.CONFIRM_REGISTRATION_FINAL:
        return t("COMMON.OK");
      case MODAL_TYPE.CONFIRM_UPDATE:
        return t("COMMON.CHANGE");
      case MODAL_TYPE.CONFIRM_REGISTRATION:
        return t("COMMON.UPDATE");
      default:
        return t("COMMON.NEXT");
    }
  };

  const isFormModalType = [
    MODAL_TYPE.REGISTRATION,
    MODAL_TYPE.DETAIL,
    MODAL_TYPE.CONFIRM_REGISTRATION,
    MODAL_TYPE.CONFIRM_UPDATE,
    MODAL_TYPE.UPDATE,
  ].includes(props.modalType);

  return (
    <CommonModalWrapper
      centered
      loading={props.isLoading}
      title={props.title}
      closeIcon={props.isCloseIcon}
      open={props.visible}
      onCancel={() => props.onClose(false)}
      width={props.width}
      maskClosable={props.isMaskClosable}
      footer={() => {
        return (
          <Row gutter={[ROW_GUTTER.HORIZONTAL, ROW_GUTTER.HORIZONTAL]}>
            {props.modalType === MODAL_TYPE.DETAIL ? (
              <Col span={24}>
                <Button
                  onClick={() => props.onClose(false)}
                  autoInsertSpace={false}
                  className="btn-next"
                >
                  {t("COMMON.CLOSE")}
                </Button>
              </Col>
            ) : (
              <>
                <Col span={12}>
                  <Button
                    disabled={props.isDisableBtnNext}
                    key={"update-btn-cancel"}
                    className={
                      props.isDisableBtnNext ? "btn-next-disable" : "btn-next"
                    }
                    autoInsertSpace={false}
                    onClick={() => handleAction(props.modalType)}
                  >
                    {handleRenderTextButton(props.modalType)}
                  </Button>
                </Col>
                <Col span={12}>
                  <Button
                    onClick={() => props.onClose(false)}
                    autoInsertSpace={false}
                    className="cancel-btn"
                  >
                    {t("COMMON.CANCEL")}
                  </Button>
                </Col>
              </>
            )}
          </Row>
        );
      }}
    >
      {isFormModalType ? (
        <Form layout="vertical" preserve={false} form={props.form}>
          <ConfigProvider
            theme={{
              components: {
                Select: {
                  optionSelectedBg: "var(--color-hover-primary) !important",
                },
              },
            }}
          >
            <Row
              gutter={[ROW_GUTTER.HORIZONTAL, ROW_GUTTER.HORIZONTAL]}
              style={{ marginBottom: "-12px" }}
            >
              {props.fieldData.map((item, index) => {
                return (
                  <Col key={Number(index)} span={12}>
                    <Form.Item {...item.fieldConfig}>{item.element}</Form.Item>
                  </Col>
                );
              })}
            </Row>
          </ConfigProvider>
        </Form>
      ) : (
        <></>
      )}
    </CommonModalWrapper>
  );
};

export { CommonModal };
